export const RELEWISE_MINIMUM_STOCK_COUNT = 2;
export const DEFAULT_PAGE_SIZE = 20;
export const NUMBER_OF_VARIANTS_PER_PRODUCT_IN_PLP = 2;
export const NUMBER_OF_VARIANTS_PER_PRODUCT_IN_AUTOSUGGEST = 2;
export const DISTINCT_COLOR_VARIANT_COUNT = 1;
export const ALL_VARIANTS_EXPLODE_COUNT = 999;

export const RELEWISE_DISPLAYED_AT_LOCATION = {
    CATEGORY_PLP: 'Category PLP',
    SEARCH_PLP: 'Search PLP',
    HEADER_SEARCH: 'Header Search',
    PDP: 'PDP',
    LANDING_PAGE: 'Landing Page',
    MY_ACCOUNT: 'My Account'
} as const;

export const MEMBER_PRICE_LABEL_FALLBACK_TEXT = 'Member Price';
export const FALLBACK_UNIT_OF_MEASURE = 'pcs';
